import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Spinner from '@cloudscape-design/components/spinner';
import Button from '@cloudscape-design/components/button';

interface Props {
  type: 'loading' | 'empty' | 'error';
  message?: string;
  onRetry?: () => void;
}

export function EmptyState({ type, message, onRetry }: Props) {
  if (type === 'loading') {
    return (
      <Box textAlign="center" padding="xl">
        <Spinner size="large" />
        <Box variant="p" color="text-body-secondary">Loading...</Box>
      </Box>
    );
  }

  return (
    <Box textAlign="center" padding="xl">
      <SpaceBetween size="s">
        <Box variant="h3" color={type === 'error' ? 'text-status-error' : 'text-body-secondary'}>
          {type === 'error' ? 'Error' : 'No tickets found'}
        </Box>
        <Box variant="p" color="text-body-secondary">
          {message ?? (type === 'error' ? 'Something went wrong.' : 'Try adjusting your filters.')}
        </Box>
        {onRetry && <Button onClick={onRetry}>Retry</Button>}
      </SpaceBetween>
    </Box>
  );
}
